import React from "react";
import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/RecurringRevenueSagas";

const CompareDates = () => {
  const dispatch = useDispatch();
  const {
    selectedFilters: { compare }
  } = useSelector((state) => state.recurringRevenue);
  return (
    <ToggleableButton
      onClick={(data) => dispatch(actionCreators.updateCompareDates(data))}
      isRadio
      isActive={compare}
    />
  );
};

export default CompareDates;
